import React, { useRef, useState, useEffect } from 'react';
import {
  Box,
  Grid,
  Avatar,
  Typography,
  Chip,
  Button,
  Paper,
  Tabs,
  Tab,
  useMediaQuery,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import UserProfileTabsContent from './UserProfileTabsContent'; // Import the separate content component
import PerformanceGauge from './PerformanceGauge';

const menuItems = [
  'PERSONAL INFO',
  'COMPANY',
  'EMPLOYMENT',
  'TEAMS',
  'PROJECTS & ROLES',
  'PAY / BILL',
  'WORK TIME & LIMITS',
  'SETTINGS',
];

const UserProfileEdit = () => {
  const [activeTab, setActiveTab] = useState(0);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const tabRefs = useRef(menuItems.map(() => React.createRef()));

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  useEffect(() => {
    if (isMobile && tabRefs.current[activeTab]?.current) {
      tabRefs.current[activeTab].current.scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
        block: 'nearest',
      });
    }
  }, [activeTab, isMobile]);

  return (
    <Box p={2}>
      <Box sx={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 2, flexWrap: { xl: 'nowrap', lg: 'nowrap', md: 'nowrap', sm: 'wrap' } }}>
        <Box className="card-body  bg-base border rounded-3 overflow-hidden h-100" sx={{
          display: 'flex',
          alignItems: 'center',
          width: '100%',
          flexWrap: { xl: 'nowrap', lg: 'nowrap', md: 'nowrap', sm: 'wrap', xs: 'nowrap' },
          padding: { xl: '24px', lg: '15px', md: '10px', sm: '10px', xs: '24px' }
        }}>
          <Avatar sx={{
            minWidth: { xl: '120px', lg: '80px', md: '80px', sm: '80px', xs: '120px', },
            maxWidth: { xl: '120px', lg: '80px', md: '80px', sm: '80px', xs: '120px' },
            width: { xl: 120, lg: 80, md: 80, sm: 80, xs: 120 },
            height: { xl: 120, lg: 80, md: 80, sm: 80, xs: 120 },
            fontSize: 28
          }}>AR</Avatar>
          <Box sx={{ width: '100%', paddingLeft: '15px' }}>
            <Box>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}>
                <Typography sx={{ fontSize: { xl: '20px', lg: '17px', md: '17px', sm: '17px', xs: '20px' }, fontWeight: '600', color: '#1A1F36' }}>
                  ANIL RAZAK <Chip label="4572" size="small" sx={{ ml: 1, background: '#FBDEB1', color: '#D36A08', borderRadius: '3px', }} />
                </Typography>
                <Chip label="Active account" sx={{ background: '#C7E4D2', border: '1px solid #179046', color: '#179046', }} variant="outlined" />
              </Box>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2, mt: 1 }}>
                Digital Marketing Specialist
              </Typography>
            </Box>
            <Box sx={{
              width: '100%',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              flexWrap: { xl: 'wrap', lg: 'wrap', md: 'wrap', sm: 'wrap', xs: 'nowrap' }
            }}>
              <Typography variant="body2" sx={{ color: '#1A1F36', fontSize: '14px', fontWeight: '600' }}><span style={{ color: '#64748B' }}>Email:</span> 1698__anil@cacedigital.com</Typography>
              <Typography variant="body2" sx={{ color: '#1A1F36', fontSize: '14px', fontWeight: '600' }}><span style={{ color: '#64748B' }}>Phone:</span> 7982590019</Typography>
              <Typography variant="body2" sx={{ color: '#1A1F36', fontSize: '14px', fontWeight: '600' }}><span style={{ color: '#64748B' }}>Time zone:</span> (GMT+05:30) Asia/Calcutta</Typography>
              <Typography variant="body2" sx={{ color: '#1A1F36', fontSize: '14px', fontWeight: '600' }}><span style={{ color: '#64748B' }}>Joined:</span> Tue, Jan 14, 2025</Typography>
            </Box>
          </Box>
        </Box>
        <Box className="card-body p-0 border rounded-3 overflow-hidden" sx={{ minWidth: { xl: '320px', lg: '260px', md: '240px', sm: '320px', xs: '320px' }, background: '#1A1F36', }}> <PerformanceGauge /></Box>
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'between',
          alignItems: 'start',
          gap: 2,
          marginTop: '24px',
          flexWrap: { xl: 'nowrap', lg: 'nowrap', md: 'nowrap', sm: 'wrap', xs: 'wrap' }
        }}
      >
        {/* Tabs (Left Side) */}
        <Box sx={{
          minWidth: { xl: '320px', lg: '210px', md: '250px', sm: '100%', xs: '100%' },
          maxWidth: { xl: '320px', lg: '210px', md: '250px', sm: '100%', xs: '100%' },
          position: 'sticky',
          top: '100px',
        }}
          className="card-body bg-base border rounded-3 overflow-hidden">
          <Paper
            elevation={1}
            sx={{
              boxShadow: 'none',
              padding: 0,
              ...(isMobile
                ? { mb: 2, overflowX: 'auto' }
                : { height: '100%', minHeight: { xl: '400px', lg: '400px', md: '400px', sm: '100%', xs: '100%' } }),
            }}
          >
            <Tabs
              value={activeTab}
              onChange={handleTabChange}
              orientation={isMobile ? 'horizontal' : 'vertical'}
              variant="scrollable"
              scrollButtons={isMobile ? 'auto' : false}
              allowScrollButtonsMobile
              sx={{
                borderColor: 'divider',
                p: 0,
                '& .MuiTabs-list': {

                  flexDirection: { xl: 'column', lg: 'column', md: 'column', sm: 'row', xs: 'row' },
                  overflowX: 'auto'
                },
                '& .MuiButtonBase-root': {
                  justifyContent: 'start',
                  textAlign: 'left'
                },
                '& .MuiTabs-indicator': {
                  backgroundColor: { xl: '#1976d2', lg: '#1976d2', md: '#1976d2', sm: '#fff', xs: '#fff' }
                }
              }}
            >
              {menuItems.map((item, index) => (
                <Tab
                  key={item}
                  label={item}
                  ref={tabRefs.current[index]}
                  sx={{
                    textTransform: 'none',
                    fontWeight: 600,
                    fontSize: 14,
                    alignItems: isMobile ? 'center' : 'flex-start',
                    flexDirection: 'row'
                  }}
                />
              ))}
            </Tabs>
          </Paper>
        </Box>

        {/* Tab Content (Right Side) */}
        <Box sx={{ flexGrow: 1 }} className="card-body bg-base border rounded-3  w-100 overflow-hidden">
          <Paper
            elevation={1}
            sx={{ padding: { xl: '24px', lg: '18px', md: '12px', sm: '24px', xs: '24px' }, borderRadius: 0, boxShadow: 'none', border: 'none', }}>
            <UserProfileTabsContent activeTab={activeTab} menuItems={menuItems} />
          </Paper>
        </Box>
      </Box>
    </Box>
  );
};

export default UserProfileEdit;
